import React, { useContext } from 'react';
import styled from 'styled-components';

import TopBar from './top-bar';
import MenuPtBr from './menu-pt-br';
import MenuEnUs from './menu-en-us';
import MenuEsEs from './menu-es-es';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  background: #2D2D2C;
`

const Footer = () => {
  const { language } = useContext(LanguageContext);
  return (
    <Container>
      <TopBar />
      { language === 'pt-br' && <MenuPtBr />}
      { language === 'en-us' && <MenuEnUs />}
      { language === 'es-es' && <MenuEsEs />}
    </Container>
  )
}

export default Footer;
